import { BaseContainerModel } from '../base-container.model';
import { bl_fi_generic_doc_message_template_placeholder_hdr_RowClass, bl_fi_generic_doc_message_template_placeholder_hdr_RowInterface } from '../../dbschema/index';

export class NotificationTemplateMessagePlaceholderContainerModel extends BaseContainerModel {
    bl_fi_generic_doc_message_template_placeholder_hdr: bl_fi_generic_doc_message_template_placeholder_hdr_RowInterface  = new bl_fi_generic_doc_message_template_placeholder_hdr_RowClass();
}
